module.exports = __webpack_public_path__ + "img/1482140536.483d3587.jpg";